import type React from 'react';
import type { ComponentProps } from 'react';

import LoadingIcon from 'components/atoms/LoadingIcon';
import { ConfirmationIcon } from '../Icons';
import { Stack } from '../Stack';
import * as Styled from './AgentWizardOptionButton.styled';

export interface AgentWizardOptionButtonProps extends ComponentProps<'button'> {
  isSelected: boolean;
  isLoading?: boolean;
  shouldShowSelectedIcon?: boolean;
  onClick: () => void;
}

export const AgentWizardOptionButton: React.FC<
  AgentWizardOptionButtonProps
> = ({
  isSelected,
  isLoading,
  shouldShowSelectedIcon = true,
  children,
  ref: _ref,
  ...rest
}) => {
  return (
    <Styled.AgentWizardOptionButton $selected={isSelected} {...rest}>
      {children}
      {isLoading ? (
        <Stack align="center" height="20px" justify="center" width="20px">
          <LoadingIcon />
        </Stack>
      ) : (
        <ConfirmationIcon
          color={
            isSelected && shouldShowSelectedIcon ? 'iconPrimary' : 'background'
          }
        />
      )}
    </Styled.AgentWizardOptionButton>
  );
};
